import AutoCompleteFilter from '../../../../components/AutoCompleteFilter'
import InputSelect from '../../../../components/InputSelect'
import { BillingEnum, getBillingLabel } from '../../../../enums/billing-enum'
import baseService from '../../../../services/baseService'

const billingStatusOptions = [
  { value: 'all', label: 'Todos' },
  { value: BillingEnum.DRAFT, label: getBillingLabel(BillingEnum.DRAFT) },
  { value: BillingEnum.PENDING, label: getBillingLabel(BillingEnum.PENDING) },
  { value: BillingEnum.APPROVED, label: getBillingLabel(BillingEnum.APPROVED) },
  {
    value: BillingEnum.CANCELLED,
    label: getBillingLabel(BillingEnum.CANCELLED),
  },
]

export const inputsFiltersBills = ({
  localFilterValues,
  handleFilterChange,
}) => [
  {
    label: 'N° Fiscal',
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="number"
        model="billings"
        value={localFilterValues.number}
        onChange={(selected) => handleFilterChange('number', selected)}
        placeholder="Filtre os faturamentos pelo número"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: 'Criado por',
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="createdBy.name"
        model="billings"
        value={localFilterValues['createdBy.name']}
        onChange={(selected) => handleFilterChange('createdBy.name', selected)}
        placeholder="Filtre os faturamentos pelo criador"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: 'Status',
    component: (
      <InputSelect
        id="status"
        label="Status"
        value={localFilterValues.status ?? 'all'}
        onChange={(e) => {
          const value = e.target.value

          handleFilterChange('status', value === 'all' ? null : value)
        }}
        options={billingStatusOptions}
      />
    ),
  },

  {
    label: 'Organização',
    component: (
      <InputSelect
        id="organization"
        label="Organização"
        value={localFilterValues['organization.alias'] ?? 'all'}
        onChange={(e) => {
          const value = e.target.value
          handleFilterChange(
            'organization.alias',

            value === 'all' ? null : value
          )
        }}
        options={[
          { value: 'all', label: 'Todas' },
          { value: 'IP', label: 'IP' },
          { value: 'AS SISTEMAS', label: 'AS SISTEMAS' },
          { value: 'ALUCOM', label: 'ALUCOM' },
        ]}
      />
    ),
  },
]
